import { z } from "zod";

export const agentNoteCommentSchema = z.object({
  comment: z
    .string()
    .trim()
    .min(1, { message: "Comment cannot be empty" })
    .max(500, { message: "Comment cannot exceed 500 characters" }),
});

export type AgentNoteCommentFormType = z.infer<typeof agentNoteCommentSchema>;

export default agentNoteCommentSchema;
